module.exports = __webpack_public_path__ + "img/newtaiyo5.321885da.png";